//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'NRS',
  data () {
    return {
      form: {
        nourishment: '',
        illness: '',
        age: '0',
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '1', name: '近3个月体质量下降＞5%；\n近1周进食量减少＞25%。'},
        {value: '2', name: '近2个月体质量下降＞5%；\n近1周进食量减少＞50%。'},
        {value: '3', name: '近1个月体质量下降＞5%；\n近1周进食量减少＞75%；\n体质量指数（BMI）＜18.5kg/㎡，及一般情况差。'}
      ],
      dataList2: [
        {value: '1', shortName: '一般恶性肿瘤、髋部骨折、长期血透、糖尿病、慢性疾病', name: '一般恶性肿瘤、髋部骨折、长期血透、糖尿病、慢性疾病（如肝硬化、慢阻肺等）。'},
        {value: '2', name: '血液恶性肿瘤、重症肺炎、腹部大型手术、脑卒中。'},
        {value: '3', name: '重症颅脑损伤、骨髓移植、重症监护、急性生理与慢性健康评分（APACHEⅡ）＞10分。'}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (form[key] == '---') {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/NRS.vue